import { render, staticRenderFns } from "./AnswerBankSoal.vue?vue&type=template&id=104a6305"
import script from "./AnswerBankSoal.vue?vue&type=script&lang=js"
export * from "./AnswerBankSoal.vue?vue&type=script&lang=js"
import style0 from "./AnswerBankSoal.vue?vue&type=style&index=0&id=104a6305&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports